"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _beforeUnloadCallbackQueue = [];

var _handleBeforeUnload = function _handleBeforeUnload(e) {
  return _beforeUnloadCallbackQueue.forEach(function (callback) {
    return callback(e);
  });
};

window.addEventListener('beforeunload', _handleBeforeUnload);
var _default = {
  addBeforeUnloadCallback: function addBeforeUnloadCallback(callback) {
    if (!callback || typeof callback !== 'function') {
      return;
    }

    _beforeUnloadCallbackQueue.push(callback);
  }
};
exports.default = _default;
module.exports = exports.default;